<template>
  <v-card>
    <v-card-title>
      <v-btn
        color="success"
        @click="openHolidaysForm('new')"
        :disabled="loading"
        small
        outline
        slot="end"
      >
        <v-icon class="pr-1">receipt_long</v-icon>Adicionar
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="holidays"
      :search="search"
      :pagination.sync="pag"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.date | formatDate }}</td>
        <td class="text-xs-center">{{ props.item.type }}</td>
        <td class="text-xs-center">
          <v-tooltip v-if="props.item.fixed_date" bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="green darken-4">task_alt</v-icon>
            </template>
            <span>Feriado é fixo</span>
          </v-tooltip>
          <v-tooltip v-else bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="error">highlight_off</v-icon>
            </template>
            <span>Feriado não é fixo</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">{{ props.item.state | formatState }}</td>
        <td class="text-xs-center">
          {{ getUtilityObj(props.item.utility_company) | formatUtilityCompany }}
        </td>
        <td class="text-xs-center">
          <v-btn
            flat
            icon
            color="grey darken-1"
            @click="openHolidaysForm('edit', props.item)"
            :disabled="loading"
          >
            <v-icon>edit</v-icon>
          </v-btn>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
              >
                <v-icon
                  left
                  @click.stop="openDeleteDialog(props.item.id)"
                  color="error"
                >
                  delete
                </v-icon>
              </v-btn>
            </template>
            <span>Deletar Feriado</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog_delete_holiday" max-width="290" dark>
      <v-card color="gray lighten-3">
        <v-card-title class="headline">
          Tem certeza que deseja excluir esse feriado?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="dialog_delete_holiday = false">
            Não
          </v-btn>
          <v-btn color="green" dark @click="deleteHoliday(holidayId)">
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <holidays-form />
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { eventBus } from "@/main";
import { deleteHolidayFb } from "../../services/holidays";
import HolidaysForm from "./HolidaysForm.vue";

export default {
  components: { HolidaysForm },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Nome",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "ID",
          value: "id",
          align: "center",
        },
        {
          text: "Data",
          value: "date",
          align: "center",
        },
        {
          text: "Tipo",
          value: "type",
          align: "center",
        },
        {
          text: "Data Fixa",
          value: "fixed_date",
          align: "center",
        },
        {
          text: "Estado",
          value: "state",
          align: "center",
        },
        {
          text: "Concessionária",
          value: "utility_company",
          align: "center",
        },
        {
          text: "Ações",
          align: "center",
        },
      ],
      pag: {
        rowsPerPage: 50,
      },
      dialog_delete_holiday: false,
      holidayId: null,
    };
  },
  mounted() {
    this.getHolidays();
    this.getUtilityCompanies();
  },
  computed: {
    ...mapState("configuration", ["loading", "holidays"]),
    ...mapGetters("configuration", ["utilityCompanyById"]),
  },
  filters: {
    formatDate: (date) => {
      if (date.year) {
        return (
          ("0" + date.day).slice(-2) +
          "/" +
          ("0" + date.month).slice(-2) +
          "/" +
          date.year
        );
      }
      return ("0" + date.day).slice(-2) + "/" + ("0" + date.month).slice(-2);
    },

    formatState: (state) => {
      if (!state) return "-";
      return state;
    },

    formatUtilityCompany: (utilityCompany) => {
      if (!utilityCompany) return "-";
      return `${utilityCompany.name}-${utilityCompany.state}`;
    },
  },
  methods: {
    ...mapActions("configuration", ["getHolidays", "getUtilityCompanies"]),

    getUtilityObj(utilityId) {
      if (!utilityId) return null;
      return this.utilityCompanyById(utilityId);
    },

    openHolidaysForm(type, data) {
      let obj = {
        status: true,
        type: type,
        data: data,
      };
      eventBus.$emit("holidaysForm", obj);
    },

    openDeleteDialog(id) {
      this.holidayId = id;
      this.dialog_delete_holiday = true;
    },

    deleteHoliday() {
      deleteHolidayFb(this.holidayId);
      this.dialog_delete_holiday = false;
    },
  },
};
</script>
